import * as _ from 'lodash'
import { assign } from 'lodash'
export class AdminWhitelistPaywayMidDto {
  mallId: string
  tenantId: string
  mid: string

  static create({mallId, tenantId, mid}) {
    return _.assign(new AdminWhitelistPaywayMidDto(), {
      mallId,
      tenantId,
      mid
    })
  }
}